import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FreeRoundsData } from "../../commander/Types";
import initialState from "../initial-state";

const freeRounds = createSlice({
  name: "freeRounds",
  initialState: initialState.freeRounds,
  reducers: {
    showFreeRounds(state) {
      return { ...state, seen: false };
    },

    activateFreeRounds(
      state,
      action: PayloadAction<{ amount: number; stake: number; cache?: any }>
    ) {
      if (
        !action.payload ||
        action.payload.amount === 0 ||
        !action.payload.stake
      )
        return { ...state, seen: true };
      const { amount, stake, cache } = action.payload;

      return { ...state, active: true, amount, stake, cache, seen: true };
    },

    declineFreeRounds(state) {
      return { ...state, active: false, seen: true };
    },

    deactivateFreeRounds(state) {
      return { ...state, active: false, amount: 0, seen: true };
    },

    resetFreeRounds(state) {
      return { ...state, active: false, seen: false, totalWin: 0, amount: 0 };
    },

    updateFreeRounds(state, action: PayloadAction<FreeRoundsData>) {
      const { amount, totalWin, stake } = action.payload;

      if (typeof amount !== "number" || amount < 0) {
        return state;
      }

      return { ...state, amount, stake, totalWin: totalWin ?? 0 };
    },
  },
});

export const {
  showFreeRounds,
  activateFreeRounds,
  declineFreeRounds,
  deactivateFreeRounds,
  updateFreeRounds,
  resetFreeRounds,
} = freeRounds.actions;

export default freeRounds;
